import {CORNER_SHELVES_POSITIONS} from "../../constants";
import AccessoryCommon from "./accessoryCommon";

export default class CornerShelf extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = "corner_shelf";
    this.partName = "Corner Shelf";
    this.translateId = "visualizer.bathroom.accessories.corner_shelf";
    this.dbName = "Small Corner Shelf";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      this.layerPositions = {};
      CORNER_SHELVES_POSITIONS.forEach(pos => {
        this.layerPositions[pos] = null
      })
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = (dbFeature.metaData["Side"] && dbFeature.metaData["Part"])
      ? dbFeature.metaData["Side"][0] + dbFeature.metaData["Part"][0]
      : ""
    const partNumber = dbFeature.metaData["layerPosition"] === CORNER_SHELVES_POSITIONS[0] ? 1 : 2;
    return super.load_(dbFeature, new CornerShelf(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  handleClick() {
    const accessoriesParent = this.getParent().getParent();
    accessoriesParent.caddie_type = this.partId;
    super.handleClick();
  }

  setLayers(layout) {

    const accessoriesParent = this.getParent();
    if (accessoriesParent.caddie_type !== this.partId) {
      super.hideLayers();
      return;
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      // this.checkIfFeaturePartIsMatching();
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }

    // if (this.layerPositions) {
    //   const windowParent = this.getParent().layout.parts.Window;
    //   if (windowParent && windowParent.windowKits && !windowParent.windowKits.disabled) {
    //     Object.keys(this.layerPositions).forEach(key => {
    //       if (!key.includes("3") && this.layerPositions[key]) {
    //         this.layerPositions[key].layer.src = '';
    //       }
    //     })
    //   }
    // }

  }

  // setZIndex(zIndexes) {
  //   if (zIndexes) {
  //     Object.keys(this.layerPositions).forEach((key, keyIndex) => {
  //       if (this.layerPositions[key]) {
  //         this.layerPositions[key].layer.zIndex = zIndexes.Accessories.CornerShelf1 + keyIndex*10;
  //       }
  //     })
  //   }
  // }

  showLayerPositionsModal() {
    return true
  }

}
